module.exports = __webpack_public_path__ + "img/trash.37d07c2d.svg";